import { generatePath } from 'react-router-dom';
import { RouteSegments } from '../routingClientAdmin.interface';

export const generateNodeStreamsRoute = (nodeId: number, streamId?: number) => {
  const pageUrl = generatePath(
    `/${RouteSegments.Root.Config}/${RouteSegments.Pools.Streams}`,
    { nodeId: String(nodeId) },
  );

  if (streamId) {
    return `${pageUrl}/${streamId}`;
  }

  return pageUrl;
};
